import { Injectable } from '@angular/core';
import { Observable, Subject } from 'rxjs';
import { ReadConfigService } from './read-config.service';
import { NotificationService } from '@progress/kendo-angular-notification';

@Injectable()
export class DisplayNotificationService {
  noPosition = 0;
  constructor(private readConfigService: ReadConfigService,
    private notificationService: NotificationService) { }
  // Get Notifications
  private notificationsubject: Subject<any> = new Subject<any>();
  getNotification$ = this.notificationsubject.asObservable();

  // Get Loading
  private loadStatus: Subject<any> = new Subject<any>();
  getLoadStatus$ = this.loadStatus.asObservable();

  // get UserName
  private userName: Subject<any> = new Subject<any>();
  getUserName$ = this.userName.asObservable();

  setUpNotification(response: { message: string, success: boolean }, isWarning: boolean = false) {
    this.notificationsubject.next({ resp: response, isWarning });
    const notifInstance = this.notificationService.show({
      content: response.message,
      position: { horizontal: 'right', vertical: 'top' },
      animation: { type: 'fade', duration: 400 },
      cssClass: 'kendo-custom-class',
      type: { style: isWarning ? 'warning' : response.success ? 'success' : 'error', icon: true },
      closable: true
    });
    setTimeout(() => {
      if (notifInstance) {
        notifInstance.hide();
      }
    }, this.readConfigService.getSuccessHideAfter());
  }

  getNotification(): Observable<any> {
    return this.notificationsubject.asObservable();
  }

  setUpLoading(status: boolean = false) {
    this.loadStatus.next({ status });
  }

  setUpUserName(username: any = '') {
    this.userName.next({ username });
  }

  setErrorNotification(message?: string) {
    const notifInstance = this.notificationService.show({
      content: message ? message : this.readConfigService.getGeneralErrorMessage(),
      position: { horizontal: 'right', vertical: 'top' },
      animation: { type: 'fade', duration: 400 },
      cssClass: 'kendo-custom-class',
      type: { style: 'error', icon: true },
      closable: true
    });
    setTimeout(() => {
      if (notifInstance) {
        notifInstance.hide();
      }
    }, this.readConfigService.getErrorHideAfter());
  }

  copyToClipboard(val: string, el: string) {
    const currel = document.getElementById(el);
    let position = currel.parentElement.offsetHeight;
    position = (position > 0 && this.noPosition === 0) ? position - 5 : 0;

    navigator.clipboard.writeText(val).then().catch(e => console.error(e));
    // tslint:disable-next-line: max-line-length
    const element = '<span class="top-margin-1"><span class="k-tooltip tooltip-validation validationError" style="margin-top:' + position + 'px">Copied</span></span>';

    if (currel) {
      currel.innerHTML = element + currel.innerHTML;
      setTimeout(() => {
        currel.innerHTML = currel.innerHTML.replace(element, '');
        this.noPosition = 0;
      }, 1500);
    }
  }

  getDataAndCopy(el: string) {
    const element = document.getElementById(el).innerText;
    this.noPosition = 1;
    this.copyToClipboard(element, el);
  }
}
